// @ts-check
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../store.js';
import { api } from '../api.js';

export default function Login() {
  const nav = useNavigate();
  const setToken = useAuth((s) => s.setToken);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit(/** @type {React.FormEvent} */ e) {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      const res = await api('/auth/admin/login', {
        method: 'POST',
        body: JSON.stringify({ email, password }),
      });
      setToken(res.access_token, res.role);
      nav('/');
    } catch (e) {
      setErr(/** @type {Error} */ (e).message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="grid place-items-center h-screen">
      <form onSubmit={submit} className="card w-96 space-y-4">
        <h1 className="text-2xl font-bold text-red-500">Katsura HQ Admin</h1>
        <label className="block">
          <span className="text-sm text-neutral-400">Email</span>
          <input type="email" className="input mt-1" value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
        </label>
        <label className="block">
          <span className="text-sm text-neutral-400">Password</span>
          <input type="password" className="input mt-1" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {err && <p className="text-red-400 text-sm">{err}</p>}
        <button type="submit" disabled={loading} className="btn-primary w-full">
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
